'use strict'

module.exports = [

	{dir: 'data', name: 'menu',
		sections: [],
	},

	{group: 'article'},
	{group: 'images'},
	{group: 'calendar'},
	{group: 'external'},
	{name: 'registration-form-zosr', groups: ['Iné'],
		sections: ['top', 'full', 'large', 'small'],
	},

]



//////////////////
// WEBPACK FOOTER
// ./data/portal2/blocks/_index.js
// module id = 274
// module chunks = 0